import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo/head";
import { resolveRouteMeta } from "@/lib/seo/routeMeta";
import RequestAccess from "@/pages/RequestAccess";

const TITLE = "Hero Stack with Ruben — Grants + Hero Benefits | Home Approach";
const DESC =
  "Heroes in New Jersey: run your free grant Stack and add your Hero Benefits Alliance layer in one form, with Ruben Nazario in your corner.";

export const Route = createFileRoute("/lp/ruben-hero/")({
  head: () =>
    buildHead({
      ...resolveRouteMeta("/lp/ruben-hero"),
      title: TITLE,
      description: DESC,
      ogTitle: TITLE,
      ogDescription: DESC,
      noIndex: true,
    }),
  // Employer-only access: this page now collects employer waitlist requests.
  component: () => <RequestAccess source="ruben-hero" hero />,
});
